import React from "react";

function RefundPolicyPage() {
    const sectionStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh',
    };

    const contentStyle = {
        maxWidth: '800px',
        background: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    };

    const headingStyle = {
        color: '#333',
        textAlign: 'center',
    };

    const lastUpdatedStyle = {
        fontStyle: 'italic',
        marginBottom: '20px',
    };

    const paragraphStyle = {
        lineHeight: '1.6',
        marginBottom: '15px',
    };

    const listStyle = {
        listStyleType: 'disc',
        paddingLeft: '20px',
    };

    return (
        <section style={sectionStyle}>
            <div style={contentStyle}>
                <h2 style={headingStyle}>Cancellation & Refund Policy </h2>
                <p style={lastUpdatedStyle}>Last updated on 21-01-2025</p>
                <p style={paragraphStyle}>TITA TECHNOLOGIES believes in helping its customers as far as possible, and has therefore a liberal
cancellation policy. Under this policy:
</p>
                <p style={paragraphStyle}>Cancellations will be considered only if the request is made immediately after placing the order.
However, the cancellation request may not be entertained if the orders have been communicated to the
vendors/merchants and they have initiated the process of shipping them.
</p>
                <p style={paragraphStyle}>TITA TECHNOLOGIES does not accept cancellation requests for perishable items like flowers,
eatables etc. However, refund/replacement can be made if the customer establishes that the quality of
product delivered is not good.
</p>
                <p style={paragraphStyle}> In case of receipt of damaged or defective items please report the same to our Customer Service team.
The request will, however, be entertained once the merchant has checked and determined the same at his
</p>
                <p style={paragraphStyle}>own end. This should be reported within the same day of receipt of the products. In case you feel
that the product received is not as shown on the site or as per your expectations, you must bring it to the
notice of our customer service within the same day of receiving the product. The Customer
Service Team after looking into your complaint will take an appropriate decision.
</p>
                <p style={paragraphStyle}> In case of complaints regarding products that come with a warranty from manufacturers, please refer
the issue to them. In case of any refunds approved by TITA TECHNOLOGIES, it'll take 3-5 days
days for the refund to be processed to the end customer.</p>
                
            </div>
        </section>
    );
};

export default RefundPolicyPage;
